import { reactive } from "vue";
import i18n from "../../../../i18n";
import { createLoading } from "../../../../utils/loading";
import { Row, Col } from "ant-design-vue";
import { has } from "../../../../utils/menu-context";
import { createButtonApprove, createButtonNotApprove, createButtonView } from "../../../../utils/button";
import {
    createPage,
    createRowActionView,
    createAppPageHeaderTop,
    createManageSelect
} from "../../../../utils/page";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { setAppPageHeader } from "../../../../components/layout/app-layout/app-layout.logic";
import { setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import {
    checkAttribute,
    initUseForm,
    onClickView
} from "../../../../utils/form";
import router from "../../../../router";
import {
    createFormCompanyAttachment
} from "../company/company.section";
import {
    createColumnsForNewRegister,
    createFieldForNewRegister,
    createRulesForNewRegister
} from "./new-user-company.section";
import store from "../../../../store";
import { callCompanyAttachmentType } from "../company/company.logic";
import { createFormForUserRegister } from "../../../account/login/register.logic";
import lodash from 'lodash'

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/userCompany";
export const routerPrefix = "new-user-companies";

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callLookupSearch = ({ criteria }) => store.dispatch(`resource/v1/master/lookup/search`, { criteria });

export const onSearch = ({ page }) => {
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [] } })
        .then(page => state.page = page)
        .finally(() => setIsLoading(false));
};

export const onClickApporveNewUser = ({ data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    return callLookupSearch({ criteria: searchLookupRefApproveOneCriteria("CONFIRM_STATUS", "Approve") }).then(page => {
        modelRef.refApproveStatus = page.data[0];
        setIsLoadingApp(true);
        return callSave({ form: data.useForm.modelRef })
            .finally(() => setIsLoadingApp(false))
            .then(() => {
                router.push({ name: routerPrefix });
            });

    });
};

export const onClickNotApporveNewUser = ({ data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;

    return callLookupSearch({ criteria: searchLookupRefApproveOneCriteria("CONFIRM_STATUS", "Reject") }).then(page => {
        modelRef.refApproveStatus = page.data[0];
        setIsLoadingApp(true);
        return callSave({ form: data.useForm.modelRef })
            .finally(() => setIsLoadingApp(false))
            .then(() => {
                router.push({ name: routerPrefix });
            });

    });
};

export const searchLookupRefApproveOneCriteria = (group, key) => {
    return {
        select: ["*"],
        page: 0,
        size: 1,
        where: [{ name: "group", type: "String", operator: "=", value: group },
            { name: "key", type: "String", operator: "=", value: key }]
    };
};

export const createSearchOneCriteria = ({ id }) => {
    return {
        select: ["*", "refCompany.**", "refCompany.refFactoryAddrTh.**", "refCompany.refFactoryAddrEn.**", "refCompany.refOfficeAddrTh.**", "refCompany.refOfficeAddrEn.**", "refUser.**"],
        page: 0,
        size: 1,
        where: [{ name: "id", type: "UUID", operator: "=", value: id }],
        children: [
            {
                name: 'refCompany.companyAttachments', select: ['*', 'refCompanyAttachmentType.*'], page: 0, size: 1000000,
                sort: [{ name: 'refCompanyAttachmentType.seq', type: 'ASC' }],
                children: [{ name: 'attachments', select: ['*'], page: 0, size: 1000000 }]
            },
         ],
    };
};

export const createFormTitle = ({ data }) => {
    return data.useForm.modelRef.id ? data.useForm.modelRef.refCompany.nameTh : i18n.global.t("button.create");
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ id }) });
    } else {
        promise = Promise.resolve({ data: [useForm.modelRef] });
    }
    return promise
        .then(page => initUseForm({ data, page, routerPrefix }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = ({ props, data, refs }) => {
    const promises = [];
    promises.push(Promise.all([callCompanyAttachmentType()])
        .then(arr => {
            data.companyAttachmentTypes = arr[0];
            createFormCompanyAttachment({ props, data, refs, isLoading, key: "refCompany" });
        }));
    return Promise.all(promises);
};

export const initState = ({ props }) => {
    const menuContext = props.menuContext;
    state.columns = createColumnsForNewRegister({ props }).map(d => {
        return lodash.mergeWith(state.columns.find(d2 => d.dataIndex === d2.dataIndex), d, (objValue, srcValue, key) => {
            if (['searchValue'].includes(key)) return objValue
        })
    })
    state.manages = [
        createManageSelect({ menuContext })
    ];
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) })
    ];
};

export const initForm = ({ props, data, refs }) => {
    checkAttribute({ props, data, refs });
    data.form = createFormForUserRegister({ props, data, refs });
    data.rules = createRulesForNewRegister();
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createFieldForNewRegister({ props, data, refs, isLoading });
    loadForm({ props, data, refs })
        .then(() => {
            if (props.setAppPageHeader) {
                setAppPageHeader({
                    slots: {
                        top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView }),
                        default: () => createAppPageHeaderDefault({ props, data, refs })
                    }
                });
            }
        });
};

export const createAppPageHeaderDefault = ({ props, data }) => {
    const col1 = [];
    const col2 = [];
    const { menuContext, viewOnly } = props;
    const { id, isActive, refApproveStatus } = data.useForm.modelRef;
    if (id && has({ menuContext, key: "canApprove" }) && refApproveStatus.key == "Wait") {
        col1.push(createButtonApprove({ onClick: () => onClickApporveNewUser({ data }), classStyle: "m-1" }));
    }
    if (id && has({ menuContext, key: "canApprove" }) && refApproveStatus.key == "Wait") {
        col1.push(createButtonNotApprove({ onClick: () => onClickNotApporveNewUser({ data }), classStyle: "m-1" }));
    }

    if (!viewOnly && id && isActive && has({ menuContext, key: "canView" })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    return <Row type="flex">
        <Col>{col1}</Col>
        <Col class="ml-auto">{col2}</Col>
    </Row>;
};

export const state = reactive({
    columns: [],
    page: createPage({ options: { select: ["*", "refApproveStatus.*", "refCompany.*", 'refCompany.refDepartment.*', 'refCompany.refBusinessType.*'], sort: [{ name: 'refCompany.createDate', type: 'DESC' }] } }),
    tableOptions: { search: { activeKey: "Search" } }
});
